import api from 'api';
import { UserTypes } from 'enums/types';

import { defaultPagination } from './general';

export const listDrivers = async (params) => api().get('/drivers', { params: { ...defaultPagination, ...params } });

export const createDriver = async ({ data }:any) => api().post('/signup', { ...data, type: UserTypes.Driver });

export const updateDriver = async ({ id, data }) => api().put(`users/${id}`, { ...data, type: UserTypes.Driver });
